/* src/app/components/analytics/email-thread-groupings/email-thread-groupings.component.scss */
.threadGroupingLink {
  text-decoration: none;
}
/*# sourceMappingURL=email-thread-groupings.component.css.map */
